import { ComponentPropsWithoutRef, FC } from 'react';

type DeleteIconProps = ComponentPropsWithoutRef<'svg'>;

export const DeleteIcon: FC<DeleteIconProps> = ({ fill, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            {...props}
        >
            <path
                d="M4.80692 14.415C4.46029 14.415 4.16437 14.2924 3.91915 14.0472C3.67392 13.802 3.55131 13.5061 3.55131 13.1594V3.55048H2.56815V2.55264H6.03365V1.68112H9.98317V2.55131H13.4487V3.55048H12.4655V13.1522C12.4655 13.5103 12.3435 13.8103 12.0996 14.0522C11.8556 14.2941 11.559 14.415 11.2099 14.415H4.80692ZM11.4664 3.55048H4.55048V13.1594C4.55048 13.2342 4.57452 13.2957 4.6226 13.3437C4.67069 13.3918 4.73213 13.4159 4.80692 13.4159H11.2099C11.274 13.4159 11.3328 13.3892 11.3862 13.3357C11.4396 13.2823 11.4664 13.2235 11.4664 13.1594V3.55048ZM6.42069 11.9391H7.41988V5.02323H6.42069V11.9391ZM8.59696 11.9391H9.59613V5.02323H8.59696V11.9391Z"
                fill={fill ?? 'currentColor'}
            />
        </svg>
    );
};
